module.exports = __webpack_public_path__ + "assets/img/3.be37da2b.png";